/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import { hot } from 'react-hot-loader/root'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Trees from '../trees/index.js'
// import Branches from '../branches/index.js'
import SnowStorm from 'react-snowstorm'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

const ARTICLE_ID = '389356860740'

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
  }

  render() {
    const dataSet = [
      {
        year: 1931,
        day: 24,
        snowZH: 1
      },
      {
        year: 1931,
        day: 25,
        snowZH: 1
      },
      {
        year: 1931,
        day: 26,
        snowZH: 1
      },
      {
        year: 1932,
        day: 24,
        snowZH: 0
      },
      {
        year: 1932,
        day: 25,
        snowZH: 0
      },
      {
        year: 1932,
        day: 26,
        snowZH: 0
      },
      {
        year: 1933,
        day: 24,
        snowZH: 2
      },
      {
        year: 1933,
        day: 25,
        snowZH: 2
      },
      {
        year: 1933,
        day: 26,
        snowZH: 2
      },
      {
        year: 1934,
        day: 24,
        snowZH: 0
      },
      {
        year: 1934,
        day: 25,
        snowZH: 0
      },
      {
        year: 1934,
        day: 26,
        snowZH: 0
      },
      {
        year: 1935,
        day: 24,
        snowZH: 19
      },
      {
        year: 1935,
        day: 25,
        snowZH: 18
      },
      {
        year: 1935,
        day: 26,
        snowZH: 17
      },
      {
        year: 1936,
        day: 24,
        snowZH: 0
      },
      {
        year: 1936,
        day: 25,
        snowZH: 0
      },
      {
        year: 1936,
        day: 26,
        snowZH: 0
      },
      {
        year: 1937,
        day: 24,
        snowZH: 1
      },
      {
        year: 1937,
        day: 25,
        snowZH: 0
      },
      {
        year: 1937,
        day: 26,
        snowZH: 0
      },
      {
        year: 1938,
        day: 24,
        snowZH: 6
      },
      {
        year: 1938,
        day: 25,
        snowZH: 6
      },
      {
        year: 1938,
        day: 26,
        snowZH: 4
      },
      {
        year: 1939,
        day: 24,
        snowZH: 0
      },
      {
        year: 1939,
        day: 25,
        snowZH: 0
      },
      {
        year: 1939,
        day: 26,
        snowZH: 0
      },
      {
        year: 1940,
        day: 24,
        snowZH: 10
      },
      {
        year: 1940,
        day: 25,
        snowZH: 10
      },
      {
        year: 1940,
        day: 26,
        snowZH: 8
      },
      {
        year: 1941,
        day: 24,
        snowZH: 0
      },
      {
        year: 1941,
        day: 25,
        snowZH: 0
      },
      {
        year: 1941,
        day: 26,
        snowZH: 0
      },
      {
        year: 1942,
        day: 24,
        snowZH: 0
      },
      {
        year: 1942,
        day: 25,
        snowZH: 0
      },
      {
        year: 1942,
        day: 26,
        snowZH: 0
      },
      {
        year: 1943,
        day: 24,
        snowZH: 0
      },
      {
        year: 1943,
        day: 25,
        snowZH: 0
      },
      {
        year: 1943,
        day: 26,
        snowZH: 0
      },
      {
        year: 1944,
        day: 24,
        snowZH: 0
      },
      {
        year: 1944,
        day: 25,
        snowZH: 0
      },
      {
        year: 1944,
        day: 26,
        snowZH: 0
      },
      {
        year: 1945,
        day: 24,
        snowZH: 0
      },
      {
        year: 1945,
        day: 25,
        snowZH: 0
      },
      {
        year: 1945,
        day: 26,
        snowZH: 0
      },
      {
        year: 1946,
        day: 24,
        snowZH: 0
      },
      {
        year: 1946,
        day: 25,
        snowZH: 0
      },
      {
        year: 1946,
        day: 26,
        snowZH: 0
      },
      {
        year: 1947,
        day: 24,
        snowZH: 0
      },
      {
        year: 1947,
        day: 25,
        snowZH: 0
      },
      {
        year: 1947,
        day: 26,
        snowZH: 0
      },
      {
        year: 1948,
        day: 24,
        snowZH: 0
      },
      {
        year: 1948,
        day: 25,
        snowZH: 0
      },
      {
        year: 1948,
        day: 26,
        snowZH: 0
      },
      {
        year: 1949,
        day: 24,
        snowZH: 0
      },
      {
        year: 1949,
        day: 25,
        snowZH: 0
      },
      {
        year: 1949,
        day: 26,
        snowZH: 0
      },
      {
        year: 1950,
        day: 24,
        snowZH: 8
      },
      {
        year: 1950,
        day: 25,
        snowZH: 7
      },
      {
        year: 1950,
        day: 26,
        snowZH: 8
      },
      {
        year: 1951,
        day: 24,
        snowZH: 0
      },
      {
        year: 1951,
        day: 25,
        snowZH: 0
      },
      {
        year: 1951,
        day: 26,
        snowZH: 0
      },
      {
        year: 1952,
        day: 24,
        snowZH: 0
      },
      {
        year: 1952,
        day: 25,
        snowZH: 0
      },
      {
        year: 1952,
        day: 26,
        snowZH: 0
      },
      {
        year: 1953,
        day: 24,
        snowZH: 0
      },
      {
        year: 1953,
        day: 25,
        snowZH: 0
      },
      {
        year: 1953,
        day: 26,
        snowZH: 0
      },
      {
        year: 1954,
        day: 24,
        snowZH: 2
      },
      {
        year: 1954,
        day: 25,
        snowZH: 3
      },
      {
        year: 1954,
        day: 26,
        snowZH: 0
      },
      {
        year: 1955,
        day: 24,
        snowZH: 0
      },
      {
        year: 1955,
        day: 25,
        snowZH: 0
      },
      {
        year: 1955,
        day: 26,
        snowZH: 0
      },
      {
        year: 1956,
        day: 24,
        snowZH: 6
      },
      {
        year: 1956,
        day: 25,
        snowZH: 4
      },
      {
        year: 1956,
        day: 26,
        snowZH: 4
      },
      {
        year: 1957,
        day: 24,
        snowZH: 0
      },
      {
        year: 1957,
        day: 25,
        snowZH: 0
      },
      {
        year: 1957,
        day: 26,
        snowZH: 0
      },
      {
        year: 1958,
        day: 24,
        snowZH: 0
      },
      {
        year: 1958,
        day: 25,
        snowZH: 16
      },
      {
        year: 1958,
        day: 26,
        snowZH: 13
      },
      {
        year: 1959,
        day: 24,
        snowZH: 0
      },
      {
        year: 1959,
        day: 25,
        snowZH: 0
      },
      {
        year: 1959,
        day: 26,
        snowZH: 0
      },
      {
        year: 1960,
        day: 24,
        snowZH: 0
      },
      {
        year: 1960,
        day: 25,
        snowZH: 0
      },
      {
        year: 1960,
        day: 26,
        snowZH: 0
      },
      {
        year: 1961,
        day: 24,
        snowZH: 0
      },
      {
        year: 1961,
        day: 25,
        snowZH: 0
      },
      {
        year: 1961,
        day: 26,
        snowZH: 1
      },
      {
        year: 1962,
        day: 24,
        snowZH: 8
      },
      {
        year: 1962,
        day: 25,
        snowZH: 9
      },
      {
        year: 1962,
        day: 26,
        snowZH: 9
      },
      {
        year: 1963,
        day: 24,
        snowZH: 2
      },
      {
        year: 1963,
        day: 25,
        snowZH: 2
      },
      {
        year: 1963,
        day: 26,
        snowZH: 2
      },
      {
        year: 1964,
        day: 24,
        snowZH: 4
      },
      {
        year: 1964,
        day: 25,
        snowZH: 2
      },
      {
        year: 1964,
        day: 26,
        snowZH: 16
      },
      {
        year: 1965,
        day: 24,
        snowZH: 0
      },
      {
        year: 1965,
        day: 25,
        snowZH: 0
      },
      {
        year: 1965,
        day: 26,
        snowZH: 0
      },
      {
        year: 1966,
        day: 24,
        snowZH: 0
      },
      {
        year: 1966,
        day: 25,
        snowZH: 0
      },
      {
        year: 1966,
        day: 26,
        snowZH: 0
      },
      {
        year: 1967,
        day: 24,
        snowZH: 0
      },
      {
        year: 1967,
        day: 25,
        snowZH: 0
      },
      {
        year: 1967,
        day: 26,
        snowZH: 0
      },
      {
        year: 1968,
        day: 24,
        snowZH: 0
      },
      {
        year: 1968,
        day: 25,
        snowZH: 4
      },
      {
        year: 1968,
        day: 26,
        snowZH: 11
      },
      {
        year: 1969,
        day: 24,
        snowZH: 11
      },
      {
        year: 1969,
        day: 25,
        snowZH: 9
      },
      {
        year: 1969,
        day: 26,
        snowZH: 8
      },
      {
        year: 1970,
        day: 24,
        snowZH: 3
      },
      {
        year: 1970,
        day: 25,
        snowZH: 4
      },
      {
        year: 1970,
        day: 26,
        snowZH: 5
      },
      {
        year: 1971,
        day: 24,
        snowZH: 0
      },
      {
        year: 1971,
        day: 25,
        snowZH: 0
      },
      {
        year: 1971,
        day: 26,
        snowZH: 0
      },
      {
        year: 1972,
        day: 24,
        snowZH: 0
      },
      {
        year: 1972,
        day: 25,
        snowZH: 0
      },
      {
        year: 1972,
        day: 26,
        snowZH: 0
      },
      {
        year: 1973,
        day: 24,
        snowZH: 0
      },
      {
        year: 1973,
        day: 25,
        snowZH: 0
      },
      {
        year: 1973,
        day: 26,
        snowZH: 1
      },
      {
        year: 1974,
        day: 24,
        snowZH: 0
      },
      {
        year: 1974,
        day: 25,
        snowZH: 0
      },
      {
        year: 1974,
        day: 26,
        snowZH: 0
      },
      {
        year: 1975,
        day: 24,
        snowZH: 3
      },
      {
        year: 1975,
        day: 25,
        snowZH: 3
      },
      {
        year: 1975,
        day: 26,
        snowZH: 3
      },
      {
        year: 1976,
        day: 24,
        snowZH: 4
      },
      {
        year: 1976,
        day: 25,
        snowZH: 4
      },
      {
        year: 1976,
        day: 26,
        snowZH: 3
      },
      {
        year: 1977,
        day: 24,
        snowZH: 0
      },
      {
        year: 1977,
        day: 25,
        snowZH: 0
      },
      {
        year: 1977,
        day: 26,
        snowZH: 0
      },
      {
        year: 1978,
        day: 24,
        snowZH: 3
      },
      {
        year: 1978,
        day: 25,
        snowZH: 0
      },
      {
        year: 1978,
        day: 26,
        snowZH: 0
      },
      {
        year: 1979,
        day: 24,
        snowZH: 11
      },
      {
        year: 1979,
        day: 25,
        snowZH: 10
      },
      {
        year: 1979,
        day: 26,
        snowZH: 8
      },
      {
        year: 1980,
        day: 24,
        snowZH: 0
      },
      {
        year: 1980,
        day: 25,
        snowZH: 0
      },
      {
        year: 1980,
        day: 26,
        snowZH: 0
      },
      {
        year: 1981,
        day: 24,
        snowZH: 9
      },
      {
        year: 1981,
        day: 25,
        snowZH: 10
      },
      {
        year: 1981,
        day: 26,
        snowZH: 9
      },
      {
        year: 1982,
        day: 24,
        snowZH: 0
      },
      {
        year: 1982,
        day: 25,
        snowZH: 0
      },
      {
        year: 1982,
        day: 26,
        snowZH: 0
      },
      {
        year: 1983,
        day: 24,
        snowZH: 0
      },
      {
        year: 1983,
        day: 25,
        snowZH: 0
      },
      {
        year: 1983,
        day: 26,
        snowZH: 0
      },
      {
        year: 1984,
        day: 24,
        snowZH: 0
      },
      {
        year: 1984,
        day: 25,
        snowZH: 2
      },
      {
        year: 1984,
        day: 26,
        snowZH: 0
      },
      {
        year: 1985,
        day: 24,
        snowZH: 0
      },
      {
        year: 1985,
        day: 25,
        snowZH: 0
      },
      {
        year: 1985,
        day: 26,
        snowZH: 0
      },
      {
        year: 1986,
        day: 24,
        snowZH: 17
      },
      {
        year: 1986,
        day: 25,
        snowZH: 16
      },
      {
        year: 1986,
        day: 26,
        snowZH: 18
      },
      {
        year: 1987,
        day: 24,
        snowZH: 0
      },
      {
        year: 1987,
        day: 25,
        snowZH: 0
      },
      {
        year: 1987,
        day: 26,
        snowZH: 0
      },
      {
        year: 1988,
        day: 24,
        snowZH: 0
      },
      {
        year: 1988,
        day: 25,
        snowZH: 0
      },
      {
        year: 1988,
        day: 26,
        snowZH: 0
      },
      {
        year: 1989,
        day: 24,
        snowZH: 0
      },
      {
        year: 1989,
        day: 25,
        snowZH: 0
      },
      {
        year: 1989,
        day: 26,
        snowZH: 0
      },
      {
        year: 1990,
        day: 24,
        snowZH: 8
      },
      {
        year: 1990,
        day: 25,
        snowZH: 7
      },
      {
        year: 1990,
        day: 26,
        snowZH: 6
      },
      {
        year: 1991,
        day: 24,
        snowZH: 0
      },
      {
        year: 1991,
        day: 25,
        snowZH: 0
      },
      {
        year: 1991,
        day: 26,
        snowZH: 0
      },
      {
        year: 1992,
        day: 24,
        snowZH: 0
      },
      {
        year: 1992,
        day: 25,
        snowZH: 0
      },
      {
        year: 1992,
        day: 26,
        snowZH: 0
      },
      {
        year: 1993,
        day: 24,
        snowZH: 0
      },
      {
        year: 1993,
        day: 25,
        snowZH: 6
      },
      {
        year: 1993,
        day: 26,
        snowZH: 9
      },
      {
        year: 1994,
        day: 24,
        snowZH: 2
      },
      {
        year: 1994,
        day: 25,
        snowZH: 2
      },
      {
        year: 1994,
        day: 26,
        snowZH: 0
      },
      {
        year: 1995,
        day: 24,
        snowZH: 0
      },
      {
        year: 1995,
        day: 25,
        snowZH: 0
      },
      {
        year: 1995,
        day: 26,
        snowZH: 5
      },
      {
        year: 1996,
        day: 24,
        snowZH: 0
      },
      {
        year: 1996,
        day: 25,
        snowZH: 0
      },
      {
        year: 1996,
        day: 26,
        snowZH: 0
      },
      {
        year: 1997,
        day: 24,
        snowZH: 0
      },
      {
        year: 1997,
        day: 25,
        snowZH: 0
      },
      {
        year: 1997,
        day: 26,
        snowZH: 0
      },
      {
        year: 1998,
        day: 24,
        snowZH: 0
      },
      {
        year: 1998,
        day: 25,
        snowZH: 2
      },
      {
        year: 1998,
        day: 26,
        snowZH: 0
      },
      {
        year: 1999,
        day: 24,
        snowZH: 3
      },
      {
        year: 1999,
        day: 25,
        snowZH: 0
      },
      {
        year: 1999,
        day: 26,
        snowZH: 0
      },
      {
        year: 2000,
        day: 24,
        snowZH: 0
      },
      {
        year: 2000,
        day: 25,
        snowZH: 0
      },
      {
        year: 2000,
        day: 26,
        snowZH: 0
      },
      {
        year: 2001,
        day: 24,
        snowZH: 9
      },
      {
        year: 2001,
        day: 25,
        snowZH: 8
      },
      {
        year: 2001,
        day: 26,
        snowZH: 6
      },
      {
        year: 2002,
        day: 24,
        snowZH: 0
      },
      {
        year: 2002,
        day: 25,
        snowZH: 0
      },
      {
        year: 2002,
        day: 26,
        snowZH: 0
      },
      {
        year: 2003,
        day: 24,
        snowZH: 2
      },
      {
        year: 2003,
        day: 25,
        snowZH: 2
      },
      {
        year: 2003,
        day: 26,
        snowZH: 2
      },
      {
        year: 2004,
        day: 24,
        snowZH: 0
      },
      {
        year: 2004,
        day: 25,
        snowZH: 0
      },
      {
        year: 2004,
        day: 26,
        snowZH: 0
      },
      {
        year: 2005,
        day: 24,
        snowZH: 0
      },
      {
        year: 2005,
        day: 25,
        snowZH: 0
      },
      {
        year: 2005,
        day: 26,
        snowZH: 0
      },
      {
        year: 2006,
        day: 24,
        snowZH: 0
      },
      {
        year: 2006,
        day: 25,
        snowZH: 0
      },
      {
        year: 2006,
        day: 26,
        snowZH: 0
      },
      {
        year: 2007,
        day: 24,
        snowZH: 0
      },
      {
        year: 2007,
        day: 25,
        snowZH: 0
      },
      {
        year: 2007,
        day: 26,
        snowZH: 0
      },
      {
        year: 2008,
        day: 24,
        snowZH: 0
      },
      {
        year: 2008,
        day: 25,
        snowZH: 1
      },
      {
        year: 2008,
        day: 26,
        snowZH: 0
      },
      {
        year: 2009,
        day: 24,
        snowZH: 0
      },
      {
        year: 2009,
        day: 25,
        snowZH: 0
      },
      {
        year: 2009,
        day: 26,
        snowZH: 0
      },
      {
        year: 2010,
        day: 24,
        snowZH: 0
      },
      {
        year: 2010,
        day: 25,
        snowZH: 13
      },
      {
        year: 2010,
        day: 26,
        snowZH: 15
      },
      {
        year: 2011,
        day: 24,
        snowZH: 0
      },
      {
        year: 2011,
        day: 25,
        snowZH: 0
      },
      {
        year: 2011,
        day: 26,
        snowZH: 0
      },
      {
        year: 2012,
        day: 24,
        snowZH: 0
      },
      {
        year: 2012,
        day: 25,
        snowZH: 0
      },
      {
        year: 2012,
        day: 26,
        snowZH: 0
      },
      {
        year: 2013,
        day: 24,
        snowZH: 0
      },
      {
        year: 2013,
        day: 25,
        snowZH: 0
      },
      {
        year: 2013,
        day: 26,
        snowZH: 0
      },
      {
        year: 2014,
        day: 24,
        snowZH: 0
      },
      {
        year: 2014,
        day: 25,
        snowZH: 0
      },
      {
        year: 2014,
        day: 26,
        snowZH: 0
      },
      {
        year: 2015,
        day: 24,
        snowZH: 0
      },
      {
        year: 2015,
        day: 25,
        snowZH: 0
      },
      {
        year: 2015,
        day: 26,
        snowZH: 0
      },
      {
        year: 2016,
        day: 24,
        snowZH: 0
      },
      {
        year: 2016,
        day: 25,
        snowZH: 0
      },
      {
        year: 2016,
        day: 26,
        snowZH: 0
      },
      {
        year: 2017,
        day: 24,
        snowZH: 0
      },
      {
        year: 2017,
        day: 25,
        snowZH: 0
      },
      {
        year: 2017,
        day: 26,
        snowZH: 0
      },

      {
        year: 2018,
        day: 24,
        snowZH: 0
      },
      {
        year: 2018,
        day: 25,
        snowZH: 0
      },
      {
        year: 2018,
        day: 26,
        snowZH: 0
      },

      {
        year: 2019,
        day: 24,
        snowZH: 0
      },
      {
        year: 2019,
        day: 25,
        snowZH: 0
      },
      {
        year: 2019,
        day: 26,
        snowZH: 0
      },
      {
        year: 2020,
        day: 24,
        snowZH: 0
      },
      {
        year: 2020,
        day: 25,
        snowZH: 1
      },
      {
        year: 2020,
        day: 26,
        snowZH: 0
      }
    ]
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical very fitted segment' id='snowstorm'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>Der Wunsch nach einer weissen Weihnacht</h1>
              <h2>
                Die Meteorologen sagen Niederschläge in den nächsten Tagen
                voraus. Die Wahrscheinlichkeit, dass es wieder einmal weisse
                Weihnacht im Schweizer Mittelland gibt, bleibt trotzdem klein.
                Es ist, wie es eben meistens ist.
              </h2>
            </div>
          </div>
          {/* <Branches /> */}
        </header>
        <SnowStorm
          animationInterval={33}
          snowStick={false}
          freezeOnBlur
          excludeMobile={false}
          flakesMax={256}
          flakesMaxActive={300}
          snowCharacter='•'
          snowColor='#fff'
          targetElement='snowstorm'
          useMeltEffect={false}
        />
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>Martin Läubli, Interaktiv-Team</div>
              <div className='ta updated'>
                Aktualisiert am 23. Dezember 2020
              </div>
            </div>
          </div>
          <div className='ui ta text container'>
            <p>
              Manche dachten wohl an eine Ironie: Ausgerechnet in diesem Jahr,
              in dem vielerorts die Skigebiete geschlossen sind und Bundesräte,
              Epidemiologen, Spitäler und Rettungsmediziner inständig bitten,
              lieber auf Skifahren und Schlitteln über die Festtage zu
              verzichten, ausgerechnet in diesem Jahr werden wir eine weisse
              Weihnacht feiern. Nun sagt der Wetterbericht von Meteo Schweiz
              zwar für Heiligabend und den Weihnachtstag Niederschlag voraus.
              Und die Schneefallgrenze sinkt. Doch es scheint, dass es für die{' '}
              <b>Mehrheit der Schweizer Bevölkerung zu warm</b> bleibt. Wer also
              bei der Bescherung vom Tannenbaum singt, der nicht nur zur
              Sommerzeit blüht, sondern auch im Winter, wenn es schneit, der
              wird vermutlich enttäuscht. Zumindest der ganz grosse Schnee im
              Mittelland bleibt aus. Eine wirklich weisse Weihnacht wird es wohl
              unterhalb von 900 Metern über Meer kaum geben.
            </p>
            <p>
              Vielleicht reicht es für Orte wie <b>Einsiedeln</b>, wo
              Weihnachten nach der Statistik von Meteo Schweiz seit Messbeginn
              1931 nur in 15 Prozent der Jahre grün war. Ansonsten feierten die
              Einsiedler an allen drei Weihnachtstagen weisse Weihnacht. Doch in
              den letzten Jahren war das nicht mehr der Fall. Es gab eine
              Häufung grüner Weihnachtstage. «Hier macht sich offensichtlich die
              Klimaveränderung mit den milderen Wintern bemerkbar», schreiben
              die Klimatologen.
            </p>
            <p>
              Der Wunsch nach weisser Weihnacht ist gross. Glückwunschkarten mit
              Schneemännern und Schnee dürfen im Adventskalender nicht fehlen,
              Weihnachtslieder besingen die schneereiche Weihnachtszeit. Und
              Grosseltern erzählen von den schneereichen Feiertagen. Doch
              statistisch gesehen, machen wir uns etwas vor. Im zentralen und
              östlichen Mittelland liegt in <b>60 Prozent</b> der Jahre an
              Weihnachten <b>kein Schnee</b>. Die Bevölkerung der West- und
              Nordwestschweiz erlebte sogar in{' '}
              <b>drei Vierteln der Jahre seit 1931 eine grüne Weihnacht</b>.
            </p>
            <p>
              So richtig winterlich war es in <b>Zürich</b> nur 20-mal seit
              Beginn der Messperiode. Das letzte Mal hat die Messstation
              Zürich-Fluntern 2003 an allen drei Weihnachtstagen Schnee
              gemessen.
            </p>
          </div>
          <div className='ui left aligned forest text container'>
            <h4 className='small title'>
              Seit 1931 gab es in Zürich nur 20 Mal wirklich weisse Weihnachten
            </h4>
            <Trees dataSet={dataSet} />
          </div>
          <div className='ui ta text container'>
            <p>
              In <b>Bern</b> war es an Weihnachten in den letzten 89 Jahren nur
              in 22 Jahren richtig weiss, das letzte Mal 2008. In <b>Basel</b>{' '}
              war es sogar nur in 12 Jahren winterlich, das letzte Mal 2010. Die
              Menschen in den tiefen Lagen der Alpensüdseite kennen praktisch
              nichts anderes als grüne Weihnachten. In Lugano gab es sechsmal
              seit 1931 eine weisse Weihnacht.
            </p>
            <p>
              Anders ist es in den höheren Lagen. In diesem Jahr sagen die
              Meteorologen an 24. und 25. Dezember Neuschnee voraus. Nicht viel,
              zwischen 10 und 30 Zentimeter. Aber immerhin. Für die
              Bergbevölkerung wird der Traum der weissen Weihnacht fast jedes
              Jahr wahr. In Davos zum Beispiel gab es nur wenige Ausnahmen: 2016
              war ein extrem schneearmer Winter. Am 24. Dezember morgens lag in
              der höchstgelegenen Stadt Europas kein Schnee.
            </p>
            <AutofitIFrame src='https://datawrapper.dwcdn.net/hzeGw/' />
            <p>
              Nun könnte man diese Entwicklung dem Klimawandel zuschreiben.
              Immerhin gab es in den letzten neun Jahren im Mittelland eine
              grüne Weihnacht. Doch auch zwischen 1941 und 1949 waren die
              Weihnachtstage schneefrei. Der Klimawandel ist eine langsame
              Veränderung, und es ist nach wie vor schwierig, einzelne Tage im
              Jahr der Erderwärmung zuzuschreiben. Es wird auch in Zukunft
              wieder weisse Weihnachten geben – trotz Klimawandel.
            </p>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          credits={[
            ['Text', 'Martin Läubli'],
            ['Idee, Programmierung', 'Interaktiv-Team'],
            ['Quellen', 'Meteo Schweiz']
          ]}
        />
      </div>
    )
  }
}

export default hot('AppComponent')
